import { render } from "./table-phase.svg?vue&type=template&id=4f4512e6?inline"
const script = {}
script.render = render

export default script